module.exports = {
	"SET_MAIN_FIGURE": "SET_MAIN_FIGURE",
	"SET_SEARCH_HOTWORDS": "SET_SEARCH_HOTWORDS",
	"SET_SEARCH_KEYWORDS": "SET_SEARCH_KEYWORDS",
	"SET_SEARCH_CATEGORY": "SET_SEARCH_CATEGORY",
	"SET_STORE_TOPICS": "SET_STORE_TOPICS",
	"SET_ACTIVE_TAB": "SET_ACTIVE_TAB",
	"SET_STORE_FILTERS": "SET_STORE_FILTERS",
	"SET_SUBMIT_FILTERS": "SET_SUBMIT_FILTERS",
	"CLEAR_SUBMIT_FILTERS": "CLEAR_SUBMIT_FILTERS",
	"SET_TEMPLATES": "SET_TEMPLATES",
	"GET_TPLS_ING": "GET_TPLS_ING",
	"GET_TPLS_SUCCEED": "GET_TPLS_SUCCEED",
	"GET_FILTERS_TPLS_SUCCEED": "GET_FILTERS_TPLS_SUCCEED",
	"GET_TPLS_FAILED": "GET_TPLS_FAILED",
	"GET_TPLS_ENDED": "GET_TPLS_ENDED",
	"CLEAR_STORE_TPLS": "CLEAR_STORE_TPLS",
	"ADD_STORE_TPLS": "ADD_STORE_TPLS",
	"SET_TPL_COLLECTION_STATUS": "SET_TPL_COLLECTION_STATUS",
	"GET_CASE_ING": "GET_CASE_ING",
	"GET_CASE_SUCCEED": "GET_CASE_SUCCEED",
	"GET_CASE_FAILED": "GET_CASE_FAILED",
	"GET_CASE_ENDED": "GET_CASE_ENDED",
	"CLEAR_STORE_CASE": "CLEAR_STORE_CASE",
	"SET_USER_INFO": "SET_USER_INFO",
	"SET_CONTENT_TOPIC": "SET_CONTENT_TOPIC",
	"SET_CONTENT_TOPIC_DETAIL": "SET_CONTENT_TOPIC_DETAIL",
	"SET_TEMPLATE": "SET_TEMPLATE",
	"SET_TEMPLATE_ERROR": "SET_TEMPLATE_ERROR",
	"SHOW_MODAL": "SHOW_MODAL",
	"HIDE_MODAL": "HIDE_MODAL",
	"SET_KEYWORD": "SET_KEYWORD",
	"SET_RELWORDS": "SET_RELWORDS",
	"SET_HOTWORDS": "SET_HOTWORDS",
	"SET_COVER": "SET_COVER",
	"GET_BASE_INFO": "GET_BASE_INFO",
	"SET_LOTTERY_INFO": "SET_LOTTERY_INFO",
	"SHOW_TIPS": "SHOW_TIPS",
	"TOGGLE_POSTER_MODAL": "TOGGLE_POSTER_MODAL",
	"ADD_SEARCH_FILTER": "ADD_SEARCH_FILTER",
	"CLEAR_SEARCH_FILTER": "CLEAR_SEARCH_FILTER",
	"CLEAR_SINGLE_FILTER": "CLEAR_SINGLE_FILTER",
	"SET_STORE_CORNER_LABEL": "SET_STORE_CORNER_LABEL",
	"SET_OPEN_ZONE_FILTERS": "SET_OPEN_ZONE_FILTERS",
	"SET_OPEN_SEARCH_FILTERS": "SET_OPEN_SEARCH_FILTERS",
	"SET_ORG_ZONE_FILTERS": "SET_ORG_ZONE_FILTERS",
	"SET_ORG_ZONE_SEARCH_FILTERS": "SET_ORG_ZONE_SEARCH_FILTERS"
}